package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_05_24_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have triumphed over the aboleth Flar’Melkhis. Dirk identifies a magical ring, Korvis collects memories of the battle, and the other heroes start to collect the coins and fine art. They examine the bodies of the humanoids. Dusk is a female human, cleric, and acolyte of Terosia (Mistress of Murder). Fitzgeorge is a human male caster. The heroes exit through the back entrance, collect the animals, and walk north for about 90 minutes.")
    }
}
